import React from 'react';

export const PcrV2Context = React.createContext<boolean | undefined>(undefined);

export default function usePcrV2(): boolean {
  // After migration to React 19, call React.use and throw errors if context value is undefined
  const value = React.useContext(PcrV2Context);
  return !!value;
}

export function usePcrV2Loading(): boolean {
  const value = React.useContext(PcrV2Context);
  return value === undefined;
}
